export async function streamChat(url, { sessionId, message, token, onDelta, onTool }) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ sessionId, message }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.detail || 'AI request failed');
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = '';
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split('\n\n');
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith('data: ')) continue;
      const j = JSON.parse(p.slice(6));
      if (j.delta) onDelta(j.delta);
      if (j.tool && onTool) onTool(j.tool);
      if (j.error) throw new Error(j.error);
      if (j.done) return;
    }
  }
}

export function getOrCreateSession(storageKey) {
  try {
    let id = localStorage.getItem(storageKey);
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) || `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(storageKey, id);
    }
    return id;
  } catch (e) {
    return `s-${Date.now()}`;
  }
}
